import { render, staticRenderFns } from "./AdmissionFormCard.vue?vue&type=template&id=5290b6b4&"
import script from "./AdmissionFormCard.vue?vue&type=script&lang=js&"
export * from "./AdmissionFormCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports